export interface INavigationRoute {
  name: string
  disabled: boolean
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  modules: [
    // {
    //   name: '',
    //   routes: [
    //     {
    //       name: 'Dashboard',
    //       displayName: 'menu.dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //   ] as INavigationRoute[],
    // },
    {
      name: '',
      routes: [
        {
          name: 'Contactos',
          displayName: 'menu.contacts.list',
          meta: {
            icon: 'group',
          },
        },
        {
          name: 'Archivados',
          displayName: 'menu.contacts.locked',
          meta: {
            icon: 'person_off',
          },
        },
        {
          name: 'Empresas',
          displayName: 'menu.contacts.juridics',
          meta: {
            icon: 'request_quote',
          },
        },
        {
          name: 'Cotizaciones',
          displayName: 'menu.oportunities.base',
          meta: {
            icon: 'request_quote',
          },
        },
      ] as INavigationRoute[],
    },
    {
      name: '',
      routes: [
        {
          name: 'contracts.list',
          displayName: 'Contratos',
          meta: {
            icon: 'summarize',
          },
        },
      ] as INavigationRoute[],
    },
    {
      name: '',
      routes: [
        {
          name: 'Ordenes de trabajo',
          displayName: 'menu.orders.base',
          meta: {
            icon: 'list_alt_check',
          },
        },
      ] as INavigationRoute[],
    },
    {
      name: '',
      routes: [
        {
          name: 'Flota',
          displayName: 'menu.fleet.base',
          meta: {
            icon: 'unpaved_road',
          },
        },
      ] as INavigationRoute[],
    },
    // {
    //   name: '',
    //   routes: [
    //     {
    //       name: 'Personal',
    //       displayName: 'menu.employees.base',
    //       meta: {
    //         icon: 'groups',
    //       },
    //     },
    //   ] as INavigationRoute[],
    // },
    // {
    //   name: '',
    //   routes: [
    //     {
    //       name: 'Combustible',
    //       displayName: 'menu.fuel.base',
    //       meta: {
    //         icon: 'gas_meter',
    //       },
    //     },
    //   ] as INavigationRoute[],
    // },
    {
      name: '',
      routes: [
        {
          name: 'Maestros',
          displayName: 'masters.base',
          meta: {
            icon: 'switch_access',
          },
        },
      ] as INavigationRoute[],
    },
  ],
}
